<div class="container-fluid glb-popup cmp-analytics-dialog">
  <p-toast [style]="{marginTop: '80px'}"></p-toast>

  <div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:4px;">
    <h2 style="margin:0;">Campaign Analytics</h2>
    @if (!isPage) {
      <div style="display:flex; align-items:center; gap:2px;">
        <button mat-icon-button title="Open in new tab" style="background-color:transparent;" (click)="openInNewTab()">
          <i class="pi pi-external-link" style="font-size:14px; color:#6a1b9a;" aria-hidden="true"></i>
        </button>
        <button mat-icon-button [mat-dialog-close]="true" style="background-color:transparent;">
          <i class="pi pi-times" aria-hidden="true"></i>
        </button>
      </div>
    }
  </div>
  <hr>

    <!-- Filter Row -->
    <div class="cmp-filter-row">
      <div class="cmp-filter-field">
        <label class="cmp-field-label">Campaign</label>
        <p-dropdown [options]="campaigns" optionLabel="displayLabel" optionValue="msgCampaignId"
          [(ngModel)]="campaignId" placeholder="Select Campaign" [filter]="true" filterBy="displayLabel"
          [showClear]="true" appendTo="body" dropdownIcon="fa fa-caret-down"
        [style]="{'width':'100%','font-size':'13px'}"></p-dropdown>
      </div>
      <div class="cmp-filter-field">
        <label class="cmp-field-label">Date From</label>
        <input pInputText type="date" [(ngModel)]="dateFrom" class="cmp-date-input" />
      </div>
      <div class="cmp-filter-field">
        <label class="cmp-field-label">Date To</label>
        <input pInputText type="date" [(ngModel)]="dateTo" class="cmp-date-input" />
      </div>
      <div class="cmp-filter-field cmp-filter-btn">
        <button pButton pRipple class="p-button p-button-sm" [loading]="loading"
          (click)="search()" [disabled]="!campaignId">
          <i class="pi pi-search" style="margin-right:6px;"></i> Search
        </button>
      </div>
    </div>

    <!-- Loading -->
    @if (loading) {
      <div style="text-align:center; padding: 40px;">
        <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
      </div>
    }

    <!-- Results -->
    @if (!loading && stats) {
      <div class="cmp-results">
        <!-- Selected Campaign Name -->
        @if (getSelectedCampaignName()) {
          <div class="cmp-selected-name">
            <i class="pi pi-megaphone" style="margin-right:6px; color:#6a1b9a;"></i>
            <b>{{getSelectedCampaignName()}}</b>
            <span class="cmp-id-badge">ID: {{campaignId}}</span>
          </div>
        }
        <!-- Stats Cards — Opened & Clicked are clickable -->
        <div class="cmp-stats-row">
          <div class="cmp-stat-card cmp-stat-sent cmp-clickable" (click)="loadRecipients('all')"
            [class.cmp-card-active]="recipientType === 'all'"
            pTooltip="Total number of recipients this campaign was sent to. Click to see all recipients with their engagement status."
            tooltipPosition="bottom">
            <div class="cmp-stat-value">{{stats.totalSent || 0}}</div>
            <div class="cmp-stat-label">Sent <i class="pi pi-external-link" style="font-size:9px;"></i></div>
          </div>
          <div class="cmp-stat-card cmp-stat-opened cmp-clickable" (click)="loadRecipients('opened')"
            [class.cmp-card-active]="recipientType === 'opened'"
            pTooltip="Unique recipients who opened the email at least once. Click to see the list."
            tooltipPosition="bottom">
            <div class="cmp-stat-value">{{stats.totalOpened || 0}}</div>
            <div class="cmp-stat-label">Opened <i class="pi pi-external-link" style="font-size:9px;"></i></div>
            @if (stats.totalSent > 0) {
              <div class="cmp-stat-sub">{{openRate | number:'1.1-1'}}%</div>
            }
          </div>
          <div class="cmp-stat-card cmp-stat-opens"
            pTooltip="Total number of open events across all recipients (includes multiple opens by the same recipient)."
            tooltipPosition="bottom">
            <div class="cmp-stat-value">{{stats.totalOpenedCount || 0}}</div>
            <div class="cmp-stat-label">Total Opens</div>
          </div>
          <div class="cmp-stat-card cmp-stat-clicked cmp-clickable" (click)="loadRecipients('clicked')"
            [class.cmp-card-active]="recipientType === 'clicked'"
            pTooltip="Unique recipients who clicked a tracked link at least once. Click to see the list."
            tooltipPosition="bottom">
            <div class="cmp-stat-value">{{stats.totalClicked_Recipients || 0}}</div>
            <div class="cmp-stat-label">Clicked <i class="pi pi-external-link" style="font-size:9px;"></i></div>
            @if (stats.totalSent > 0) {
              <div class="cmp-stat-sub">{{clickRate | number:'1.1-1'}}%</div>
            }
          </div>
          <div class="cmp-stat-card cmp-stat-clicks"
            pTooltip="Total number of link click events across all recipients (includes multiple clicks by the same recipient)."
            tooltipPosition="bottom">
            <div class="cmp-stat-value">{{stats.totalClickSum || 0}}</div>
            <div class="cmp-stat-label">Total Clicks</div>
          </div>
        </div>
        <!-- Funnel Bar -->
        @if (stats.totalSent > 0) {
          <div class="cmp-funnel">
            <h3 class="cmp-section-title">Engagement Funnel</h3>
            <div class="cmp-funnel-row">
              <span class="cmp-funnel-label">Sent</span>
              <div class="cmp-funnel-bar-wrap">
                <div class="cmp-funnel-bar cmp-bar-sent" style="width: 100%;"></div>
              </div>
              <span class="cmp-funnel-count">{{stats.totalSent}}</span>
            </div>
            <div class="cmp-funnel-row">
              <span class="cmp-funnel-label">Opened</span>
              <div class="cmp-funnel-bar-wrap">
                <div class="cmp-funnel-bar cmp-bar-opened"
                [ngStyle]="{'width': (stats.totalOpened / stats.totalSent * 100) + '%'}"></div>
              </div>
              <span class="cmp-funnel-count">{{stats.totalOpened}} ({{openRate | number:'1.1-1'}}%)</span>
            </div>
            <div class="cmp-funnel-row">
              <span class="cmp-funnel-label">Clicked</span>
              <div class="cmp-funnel-bar-wrap">
                <div class="cmp-funnel-bar cmp-bar-clicked"
                [ngStyle]="{'width': (stats.totalClicked_Recipients / stats.totalSent * 100) + '%'}"></div>
              </div>
              <span class="cmp-funnel-count">{{stats.totalClicked_Recipients}} ({{clickRate | number:'1.1-1'}}%)</span>
            </div>
          </div>
        }
        <!-- URL Click Breakdown (Campaign-specific) -->
        @if (urlClicks.length > 0) {
          <div class="cmp-url-section">
            <h3 class="cmp-section-title">URL Click Breakdown</h3>
            <div class="cmp-url-table-wrap">
              <table class="cmp-url-table">
                <thead>
                  <tr>
                    <th style="text-align:center; width:50px;">#</th>
                    <th>Destination URL</th>
                    <th>Redirect URL</th>
                    <th style="text-align:center; width:80px;">Clicks</th>
                    <th style="text-align:center; width:90px;">Recipients</th>
                  </tr>
                </thead>
                <tbody>
                  @for (u of urlClicks; track u) {
                    <tr>
                      <td style="text-align:center; font-weight:600;">{{u.urlIndex != null ? u.urlIndex : '-'}}</td>
                      <td class="cmp-td-url" title="{{u.destinationUrl}}"><a [href]="u.destinationUrl" target="_blank" rel="noopener">{{u.destinationUrl}}</a></td>
                      <td class="cmp-td-url" title="{{u.redirectUrl}}"><a [href]="u.redirectUrl" target="_blank" rel="noopener">{{u.redirectUrl}}</a></td>
                      <td style="text-align:center; font-weight:600;">{{u.clickCount}}</td>
                      <td style="text-align:center;">{{u.recipientCount}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
        @if (urlLoading) {
          <div style="text-align:center; padding:16px;">
            <i class="pi pi-spin pi-spinner" style="font-size:1.2rem;"></i> Loading URL breakdown...
          </div>
        }
        <!-- No data message -->
        @if (stats.totalSent === 0) {
          <div class="cmp-no-data">
            <i class="pi pi-info-circle" style="font-size:1.5rem; color:#999; margin-bottom:8px;"></i>
            <p>No tracked links found for this campaign in the selected date range.</p>
          </div>
        }
        <!-- Recipient Detail Table -->
        @if (recipientType) {
          <div class="cmp-recipient-section">
            <h3 class="cmp-section-title">
              {{recipientType === 'all' ? 'All' : recipientType === 'opened' ? 'Opened' : 'Clicked'}} Recipients ({{recipients.length}})
            </h3>
            @if (recipientLoading) {
              <div style="text-align:center; padding:20px;">
                <i class="pi pi-spin pi-spinner" style="font-size:1.5rem;"></i>
              </div>
            }
            @if (!recipientLoading && recipients.length === 0) {
              <div class="cmp-no-data">
                <p>No recipients found.</p>
              </div>
            }
            @if (!recipientLoading && recipients.length > 0) {
              <div class="cmp-recipient-table-wrap">
                <table class="cmp-recipient-table">
                  <thead>
                    <tr>
                      @if (recipientType === 'all') {
                        <th>Status</th>
                      }
                      <th>Recipient Id</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Mobile</th>
                      <th>Msg Id</th>
                      <th>Source</th>
                      <th>Topic</th>
                      <th>Topic Id</th>
                      <th>Opened</th>
                      <th class="cmp-th-sort" (click)="sortRecipients('openedCount')">
                        Open# <i [class]="getSortIcon('openedCount')"></i>
                      </th>
                      <th>Deferred</th>
                      <th class="cmp-th-sort" (click)="sortRecipients('deferredCount')">
                        Defer# <i [class]="getSortIcon('deferredCount')"></i>
                      </th>
                      <th>Clicked</th>
                      <th class="cmp-th-sort" (click)="sortRecipients('clickedCount')">
                        Click# <i [class]="getSortIcon('clickedCount')"></i>
                      </th>
                      @if (recipientType === 'clicked') {
                        <th class="cmp-th-sort" (click)="sortRecipients('clickedUrl')">
                          Clicked URL <i [class]="getSortIcon('clickedUrl')"></i>
                        </th>
                      }
                      @if (recipientType === 'clicked') {
                        <th>Redirect URL</th>
                      }
                      @if (recipientType === 'clicked') {
                        <th class="cmp-th-sort" (click)="sortRecipients('linkClickedAt')">
                          Click Time <i [class]="getSortIcon('linkClickedAt')"></i>
                        </th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (r of pagedRecipients; track r) {
                      <tr>
                        @if (recipientType === 'all') {
                          <td>
                            <span class="cmp-engagement-badge"
                              [ngClass]="{'badge-clicked': r.engagementStatus === 'Clicked', 'badge-opened': r.engagementStatus === 'Opened', 'badge-not-opened': r.engagementStatus === 'Not Opened'}">
                              {{r.engagementStatus}}
                            </span>
                          </td>
                        }
                        <td>{{r.msgRecipientId}}</td>
                        <td>{{r.firstName}} {{r.lastName}}</td>
                        <td class="cmp-td-email">{{r.email}}</td>
                        <td>{{r.mobileCountryCode ? '+' + r.mobileCountryCode : ''}} {{r.mobileNum}}</td>
                        <td>
                          @if (r.msgId) {
                            <a class="cmp-msg-link" title="Open Message"
                              (click)="openMessage(r.msgId)">
                              {{r.msgId}}
                              <i class="pi pi-external-link" style="font-size:9px; margin-left:2px;"></i>
                            </a>
                          }
                          @if (!r.msgId) {
                            <span>-</span>
                          }
                        </td>
                        <td>{{r.sourceType}}</td>
                        <td>{{getTopicName(r.topic)}}</td>
                        <td>
                          @if (r.reservationId) {
                            <a class="cmp-res-badge cmp-res-link" title="Open Order"
                              (click)="openOrder(r.reservationId)">
                              Res# {{r.reservationId}}
                              @if (openingOrder[r.reservationId]) {
                                <i class="pi pi-spin pi-spinner" style="font-size:10px; margin-left:3px;"></i>
                              }
                            </a>
                          }
                          @if (!r.reservationId) {
                            <span>{{r.topicId || '-'}}</span>
                          }
                        </td>
                        <td class="cmp-td-date">{{r.openedDate | date:'M/d/yy h:mm a'}}</td>
                        <td style="text-align:center;">{{r.openedCount || 0}}</td>
                        <td class="cmp-td-date">{{r.deferredDate | date:'M/d/yy h:mm a'}}</td>
                        <td style="text-align:center;">{{r.deferredCount || 0}}</td>
                        <td class="cmp-td-date">{{r.clickedDate | date:'M/d/yy h:mm a'}}</td>
                        <td style="text-align:center;">{{r.clickedCount || 0}}</td>
                        @if (recipientType === 'clicked') {
                          <td class="cmp-td-url" title="{{r.clickedUrl}}">
                            @if (r.clickedUrl) {
                              <a [href]="r.clickedUrl" target="_blank" rel="noopener">{{r.clickedUrl}}</a>
                            }
                            @if (!r.clickedUrl) {
                              <span>-</span>
                            }
                          </td>
                        }
                        @if (recipientType === 'clicked') {
                          <td class="cmp-td-url" title="{{r.redirectUrl}}">
                            @if (r.redirectUrl) {
                              <a [href]="r.redirectUrl" target="_blank" rel="noopener">{{r.redirectUrl}}</a>
                            }
                            @if (!r.redirectUrl) {
                              <span>-</span>
                            }
                          </td>
                        }
                        @if (recipientType === 'clicked') {
                          <td class="cmp-td-date">{{r.linkClickedAt | date:'M/d/yy h:mm a'}}</td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
                <p-paginator [rows]="recipientPageSize" [totalRecords]="recipients.length"
                  [rowsPerPageOptions]="[25, 50, 100]" (onPageChange)="onRecipientPageChange($event)"
                [first]="recipientPage * recipientPageSize"></p-paginator>
              </div>
            }
          </div>
        }
      </div>
    }

    <!-- Initial state -->
    @if (!loading && !stats) {
      <div class="cmp-initial">
        <i class="pi pi-megaphone" style="font-size:2.5rem; color:#ccc;"></i>
        <p style="color:#999; margin-top:10px;">Select a campaign and click Search to view analytics.</p>
      </div>
    }

  </div>
